/**
 * Áreas físicas de CliniCAT — usadas en solicitudes de material, salidas de almacén
 * y asignación de formularios.
 */

export type AreaId =
  | 'consultorio_1'
  | 'consultorio_2'
  | 'quirofano'
  | 'internacion'
  | 'laboratorio'
  | 'recepcion'
  | 'vetpraxis'
  | 'otra';

export interface AreaDef {
  id: AreaId;
  nombre: string;
  descripcion?: string;
}

export const AREAS: AreaDef[] = [
  { id: 'consultorio_1', nombre: 'Consultorio 1', descripcion: 'Atención general' },
  { id: 'consultorio_2', nombre: 'Consultorio 2', descripcion: 'Atención general' },
  { id: 'quirofano', nombre: 'Quirófano', descripcion: 'Cirugías' },
  { id: 'internacion', nombre: 'Internación', descripcion: 'Pacientes hospitalizados' },
  { id: 'laboratorio', nombre: 'Laboratorio', descripcion: 'Análisis y muestras' },
  { id: 'recepcion', nombre: 'Recepción', descripcion: 'Farmacia interna' },
  { id: 'vetpraxis', nombre: 'Vetpraxis', descripcion: 'Sucursal externa' },
  { id: 'otra', nombre: 'Otra', descripcion: 'Sin área específica' },
];

export const AREA_BY_ID: Record<AreaId, AreaDef> = AREAS.reduce(
  (acc, a) => ({ ...acc, [a.id]: a }),
  {} as Record<AreaId, AreaDef>,
);

export function areaNombre(id: AreaId | string | null | undefined): string {
  if (!id) return '—';
  return AREA_BY_ID[id as AreaId]?.nombre ?? String(id);
}
